import { MessagingBlock } from '@strata/react-messaging-block';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useEffect } from 'react';

import Closing1 from 'assets/closing-1.svg?react';
import Closing2 from 'assets/closing-2.svg?react';
import Closing3 from 'assets/closing-3.svg?react';
import { useGetLiveReferralHoursQuery } from 'store/api/auctionApi';

dayjs.extend(utc);
dayjs.extend(timezone);

const ClosingSoonIcon = ({ end }: { end: number }) => {
    const hoursRemaining = end - dayjs().tz('America/New_York').hour();

    // 3 hours until close
    if (hoursRemaining >= 3) {
        return <Closing1 />;
    }
    // 2 hours until close
    if (hoursRemaining === 2) {
        return <Closing2 />;
    }
    // 1 hour until close
    return <Closing3 />;
};

export const ClosingSoonRow = () => {
    const { data } = useGetLiveReferralHoursQuery();

    // Needed to set the colspan of the closing soon row
    useEffect(() => {
        document
            .getElementsByClassName('griddle-row--closing-soon')?.[0]
            ?.children?.[0]?.setAttribute('colspan', '7');
    }, []);

    return (
        <MessagingBlock
            className="sds_closing-soon"
            icon={<ClosingSoonIcon end={data?.end ?? 0} />}
            size={MessagingBlock.Sizes.MEDIUM}
            primaryText="We're winding down the day."
            secondaryText="No more Live Referrals will be added today."
        />
    );
};
